/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coauthoring is available in supported Microsoft 365 and web workflows.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`受支持的 Microsoft 365 与网页流程可提供共同创作。`)
};

/**
* | output |
* | --- |
* | "Coauthoring is available in supported Microsoft 365 and web workflows." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_2 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.3.2" }